import {SurveyData} from 'screens/InsomniaSurvey/utils/surveyData';

export const getEmailFromSurveyData = () => {
  const surveyData = SurveyData.read();
  return surveyData?.email;
};
